var _defs, _g, _g2, _g3, _g4, _g5, _path, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSitSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.523,
    height: 103.399,
    viewBox: "0 0 60.523 103.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#39a32e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.329 69.835)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.466,47.351H62.977a1.926,1.926,0,0,1,1.736,2.072v.847a1.926,1.926,0,0,1-1.736,2.072H23.466Z",
    transform: "translate(-23.466 -47.351)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 77.011)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.123,71.947,35.006,50.708h5.605L27.478,74.384a2.192,2.192,0,0,1-2.984.842l-.526-.3A2.193,2.193,0,0,1,23.123,71.947Z",
    transform: "translate(-22.845 -50.708)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.533 77.011)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.844,71.947,37.964,50.708H32.917L45.49,74.384a2.195,2.195,0,0,0,2.987.842l.526-.3A2.192,2.192,0,0,0,49.844,71.947Z",
    transform: "translate(-32.917 -50.708)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.329 19.696)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.466,26.433V71.9h4.99V26.433A2.383,2.383,0,0,0,26.262,23.9h-.6A2.384,2.384,0,0,0,23.466,26.433Z",
    transform: "translate(-23.466 -23.898)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.634 28.365)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.854,30.275l3.13,17.417a.287.287,0,0,0,.152.205l1.766.887-.992-14.046A7.9,7.9,0,0,0,33.9,27.953,6.109,6.109,0,0,1,34.854,30.275Z",
    transform: "translate(-20.904 -27.953)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M44,52.939l-4.036-2.027a4.588,4.588,0,0,1-2.441-3.269l-3.13-17.413A1.893,1.893,0,0,0,32.52,28.66c-.062,0-.126,0-.19.009a1.906,1.906,0,0,0-1.676,2.326l4.609,20.1a1.326,1.326,0,0,0,.8.943c8.442,3.408,17.584,7.093,19.636,7.906.028-.06.053-.133.083-.216.22-.669.1-.782-.376-1.065l-2.8-1.407L44.152,55.1Z",
    transform: "translate(-24.651 -27.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M69.686,65.706c-.577-2.578-2.245-5.883-3.891-6.9l-.532-.21-1.956-.5a5.872,5.872,0,0,1-.314,1.926,6.565,6.565,0,0,1-.844,1.725,3.569,3.569,0,0,1-2,1.447c-1.6.359-3.239-.509-4.678-1.084q-2.921-1.167-5.838-2.347-5.708-2.3-11.41-4.6l-.6-.242a5.612,5.612,0,0,1-3.361-3.951l-4.609-20.1a6.116,6.116,0,0,1-.15-1.255A9.515,9.515,0,0,0,27.819,35.1l2.155,20.874a10.208,10.208,0,0,0,9.511,9.141l19.281,1.216c1.253.244,1.387,1.2,2.114,2.632,0,0,8.819,24.9,9.973,28.446.419,1.272,1.154,3.549,2.89,3.679a3.9,3.9,0,0,0,3.964-3.7Z",
    transform: "translate(-27.819 -26.064)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M57.732,63.216c0,.017,0,.017-.019.015a2.478,2.478,0,0,1-1.2.021c-.165-.038-15.046-6.046-20.121-8.094a3.459,3.459,0,0,1-2.078-2.446l-4.611-20.1a4.046,4.046,0,0,1,3.559-4.932h0a4.046,4.046,0,0,1,4.368,3.309l.244,1.349L40.764,48.4a2.429,2.429,0,0,0,1.3,1.738l15.576,7.827a3.168,3.168,0,0,1,.094,5.248",
    transform: "translate(-15.154 0.079)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 12.009,
    cy: 12.009,
    rx: 12.009,
    ry: 12.009,
    transform: "translate(8.164 0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitSelected);
export default __webpack_public_path__ + "static/media/SitSelected.4879bc4473bcbbf9adbebfae16a879ec.svg";
export { ForwardRef as ReactComponent };